const palette = {
  light: {
    primary: {
      main: "#087C67",
      dark: "#075E54",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F58220",
      dark: "#CC6210",
    },
    success: { main: "#149954" },
    error: { main: "#D32F2F" },
    text: { secondary: "rgba(0, 0, 0, 0.6)" },
    background: {
      default: "#F5F5F5",
      paper: "#FAFAFA",
      chat: "#F5F5F5",
    },
    action: { selected: "rgba(8, 124, 103, 0.12)" },
    cards: { background: "#FFF" },
    appBar: { background: "#075E54" },
    scrollbar: { thumb: "rgba(0,0,0,.1)" },
    userMessage: { main: "#E0E0E0" },
    contactMessage: { main: "#FFFFFF" },
    timestamp: { background: "#EEEEEE" },
    queue: { fallback: "#7C7C7C" },
  },
  dark: {
    primary: {
      main: "#80DDB4",
      dark: "#087C67",
      contrastText: "#101820",
    },
    secondary: {
      main: "#FFAB60",
      dark: "#F58220",
    },
    success: { main: "#36C478" },
    error: { main: "#F44336" },
    background: {
      default: "#242424",
      paper: "#1E1E1E",
      chat: "#121212",
    },
    action: { selected: "#21463D" },
    cards: { background: "#2C2C2C" },
    appBar: { background: "#075E54" },
    scrollbar: { thumb: "hsla(0,0%,100%,.16)" },
    userMessage: { main: "#424242" },
    contactMessage: { main: "#2C2C2C" },
    timestamp: { background: "#242424" },
    queue: { fallback: "#7C7C7C" },
  },
};

export default palette;
